import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorPage from "../../shared/ErrorPage";
import Loading from "../../shared/Loading";
import axiosInstance from "../../utilities/axiosInstance/axiosInstance";
import Swal from "sweetalert2";
import CheckOutCard1 from "../../components/CartCheckOrderCard/CkeckOutCard1";

const CheckOut = ({ handleChanges, changes }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [isDiscounted, setIsDiscounted] = useState(false);

  const [q, setQ] = useState(0);
  const [st, setST] = useState(0);
  const [gt, setGT] = useState(0);
  const [dc, setDC] = useState(120);
  const [productArray, setproductArray] = useState([]);

  // discount data
  const {
    isLoading,
    isError,
    data: discount,
    error,
  } = useQuery(["discountdata"], async () => {
    let fdata = await axiosInstance.get("discount/get-active?limit=1");
    // console.log(fdata.data[0]);
    return fdata.data[0];
  });
  // cart dataa
  const {
    isLoading1,
    isError1,
    data: cartdata,
    error1,
  } = useQuery(["cartdatachkoutpage", changes], async ({ changes }) => {
    console.log(changes);
    let returndata = await axiosInstance.get(
      `cart/find-details?userId=${userInfo?._id}`
    );
    let pa = [];
    let stTem = 0;
    returndata?.data?.products?.map((x) => {
      let upd =
        x?.productId?.unit_price -
        (x?.productId?.unit_price * discount?.value) / 100;

      stTem += (x?.productId?.unit_price - upd) * x?.quantity;

      pa.push({
        productId: x?.productId?._id,
        quantity: x?.quantity,
        purchase_price: upd,
      });
    });
    setproductArray(pa);
    setST(stTem);
    setGT(stTem + dc);
    return returndata?.data;
  });

  const {
    register,
    resetField,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  console.log(cartdata === null);
  // create order
  const onSubmit = async (data) => {
    userInfo?.name
      ? (data.buyer_name = userInfo?.name)
      : (data.buyer_name = "");
    userInfo?.phone
      ? (data.phone = userInfo?.phone)
      : (data.phone = data.phone);
    userInfo?.email
      ? (data.email = userInfo?.email)
      : (data.email = data.email);
    data.userId = userInfo?._id;
    data.products = productArray;
    data.amount = gt;

    console.log(data);

    Swal.fire({
      title: "Place an order?",
      text: "You will be ordering your cart products!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes! Place Order",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axiosInstance.post("order/create", data).then((res) => {
          console.log(res.data);
          setLoading(false);
          if (res.status === 201) {
            Swal.fire(
              "Congratulations!",
              "Your order has been Placed",
              "success"
            ).then(() => {
              let res = axiosInstance.delete(
                `cart/delete?_id=${cartdata._id}&userId=${userInfo._id}`
              );
              console.log(res);
              if (res.status === 200) {
                handleChanges(changes + 1);
                navigate("/my-orders");
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: res.response.data.message || res.response.data,
            });
          }
        });
        setLoading(false);
      }
    });
  };

  if (isLoading1 || isLoading || loading) return <Loading></Loading>;
  return (
    <div className="w-full flex flex-col justify-center items-center lg:px-20 sm:px-4 my-20">
      <div className=" w-full max-w-5xl">
        <div className="">
          <form onSubmit={handleSubmit(onSubmit)}>
            <p className="underline text-gray-500 text-sm font-bold">
              Buyer Information
            </p>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-3">
              {/* name */}
              <div className="form-control w-full max-w-xs">
                <label className="label">
                  <span className="label-text  text-xs">Your Name?</span>
                </label>
                <input
                  {...register("buyer_name", {
                    required: userInfo?.name ? false : true,
                  })}
                  type="text"
                  disabled={userInfo?.name ? true : false}
                  value={userInfo?.name}
                  placeholder="Type here"
                  className="input input-bordered  text-xs w-full max-w-xs  rounded-none"
                />
                <label className="label">
                  {errors.name && (
                    <span className="label-text-alt text-sm text-red-500">
                      This field is required
                    </span>
                  )}
                </label>
              </div>
              {/* phone */}
              <div className="form-control w-full max-w-xs">
                <label className="label">
                  <span className="label-text  text-xs">Phone Number</span>
                </label>
                <input
                  {...register("phone", {
                    required: userInfo?.phone ? false : true,
                  })}
                  type="text"
                  disabled={userInfo?.phone ? true : false}
                  value={userInfo?.phone}
                  placeholder="Type here"
                  className="input input-bordered  text-xs w-full max-w-xs  rounded-none"
                />
                <label className="label">
                  {errors.phone && (
                    <span className="label-text-alt text-sm text-red-500">
                      This field is required
                    </span>
                  )}
                </label>
              </div>
              {/* email  */}
              <div className="form-control w-full max-w-xs">
                <label className="label">
                  <span className="label-text  text-xs">Your Email?</span>
                </label>
                <input
                  {...register("email", {
                    required: userInfo?.email ? false : true,
                  })}
                  type="email"
                  value={userInfo?.email}
                  disabled={userInfo?.email ? true : false}
                  placeholder="Type here"
                  className="input input-bordered  text-xs w-full max-w-xs  rounded-none"
                />
                <label className="label">
                  {errors.email && (
                    <span className="label-text-alt text-sm text-red-500">
                      This field is required
                    </span>
                  )}
                </label>
              </div>
            </div>

            {/* address  */}
            <div className="form-control">
              <label className="label">
                <span className="label-text  text-xs">Your Address</span>
              </label>
              <textarea
                {...register("address", {
                  required: true,
                })}
                className="textarea textarea-bordered h-24 text-xs rounded-none"
                placeholder="Type Here"
              ></textarea>
              <label className="label">
                {errors.address && (
                  <span className="label-text-alt text-sm text-red-500">
                    This field is required
                  </span>
                )}
              </label>
            </div>

            <p className="underline text-gray-500 text-sm font-bold mt-6">
              Product Information
            </p>

            <div className="grid grid-cols-1 gap-4 mt-6 w-full">
              {cartdata?.products.map((x, index) => {
                return (
                  <CheckOutCard1
                    discount={discount}
                    key={index}
                    data={x}
                  ></CheckOutCard1>
                );
              })}
            </div>
            <div className="mt-6 p-5 flex justify-between w-full bg-green-300">
              <div></div>
              <div>
                <p className="">Sub Total: {st}</p>
                <p className="">Delivery Charge: {dc}</p>
                <p className="text-lg font-semibold">Grand Total: {gt}</p>
              </div>
            </div>

            <div className="modal-action justify-center mt-10 mb-8">
              <input
                disabled={cartdata !== null ? false : true}
                type="submit"
                value="Place Order"
                className="btn btn-success rounded-none btn-wide"
              ></input>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CheckOut;
